import { render, staticRenderFns } from "./decclean.vue?vue&type=template&id=f41bfaee&scoped=true&"
import script from "./decclean.vue?vue&type=script&lang=js&"
export * from "./decclean.vue?vue&type=script&lang=js&"
import style0 from "./decclean.vue?vue&type=style&index=0&id=f41bfaee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f41bfaee",
  null
  
)

export default component.exports